import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const DepartmentSidePanel = () => {
    const params = useParams();

    useEffect(() => {
        console.log("params :", params.id);
    }, [params])

    return <></>;
}